import { OrderModel } from '@merchant-clients/order';

import { OrdersSortField } from '../order-sort.model';

/**
 * Sorts orders by the selected field without mutating the input.
 * Time sorting prefers the requested time and falls back to creation time.
 */
export function sortOrders(
  orders: OrderModel[],
  sortField: OrdersSortField = 'VERIFICATION',
  sortDirection: 'ASC' | 'DESC' = 'ASC',
): OrderModel[] {
  const direction = sortDirection === 'ASC' ? 1 : -1;

  return [...orders].sort((a, b) => {
    if (sortField === 'TIME') {
      const timeA = Date.parse(a.timeRequested ?? a.createdAt);
      const timeB = Date.parse(b.timeRequested ?? b.createdAt);
      return (timeA - timeB) * direction;
    }

    if (a.verification == null && b.verification == null) return 0;
    if (a.verification == null) return -1 * direction;
    if (b.verification == null) return direction;
    return (a.verification - b.verification) * direction;
  });
}

export function sortOrdersByVerification(orders: OrderModel[]): OrderModel[] {
  return sortOrders(orders);
}
